<template>
    <div>
        <input :value="data"
               ref="input"/>
    </div>
</template>

<script>
	export default {
		name: "TextInput",
		props: {
			data: {
				required: true
			}
		},
		methods: {
			getValue() {
				return this.$refs.input.value;
			}
		}
	}
</script>

<style scoped>
    input {
        width: 100%;
        max-width: 600px;
        box-sizing: border-box;
    }
</style>